export type OcrEngineValue = "tesseract" | "ai_vision" | "paddle_ocr" | "true_paddle" | "none";

const OCR_ENGINE_ALIASES: Record<string, OcrEngineValue> = {
  tesseract: "tesseract",
  tesseract_browser: "tesseract",
  ai_vision: "ai_vision",
  ai_vision_ocr: "ai_vision",
  paddle_ocr: "paddle_ocr",
  paddleocr: "paddle_ocr",
  true_paddle: "true_paddle",
  true_paddle_local: "true_paddle",
  none: "none",
};

const OCR_ENGINE_LABELS: Record<OcrEngineValue, string> = {
  tesseract: "Tesseract (Browser)",
  ai_vision: "AI Vision",
  paddle_ocr: "PaddleOCR (Vision AI)",
  true_paddle: "True Paddle OCR (Local)",
  none: "None",
};

function toCanonicalKey(raw: unknown): string {
  return String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function parseOcrEngine(raw: unknown): OcrEngineValue | null {
  const key = toCanonicalKey(raw);
  if (!key) return null;
  return OCR_ENGINE_ALIASES[key] ?? null;
}

export function normalizeOcrEngine(raw: unknown, fallback: OcrEngineValue = "tesseract"): OcrEngineValue {
  return parseOcrEngine(raw) ?? fallback;
}

export function getOcrEngineLabel(raw: unknown, fallbackLabel = "Unknown"): string {
  const parsed = parseOcrEngine(raw);
  return parsed ? OCR_ENGINE_LABELS[parsed] : fallbackLabel;
}

export function getOcrEngineFromConfig(config: Record<string, unknown> | null): OcrEngineValue | null {
  if (!config) return null;
  return (
    parseOcrEngine(config.ocr_engine_used) ??
    parseOcrEngine(config.ocr_engine_selected) ??
    parseOcrEngine(config.ocr_engine) ??
    null
  );
}
